import { render, staticRenderFns } from "./SignatoryList.vue?vue&type=template&id=dcaa522a&scoped=true"
import script from "./SignatoryList.vue?vue&type=script&lang=js"
export * from "./SignatoryList.vue?vue&type=script&lang=js"
import style0 from "./SignatoryList.vue?vue&type=style&index=0&id=dcaa522a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcaa522a",
  null
  
)

export default component.exports